var _excluded = ["background", "className", "defaultValue", "disabled", "disableLabelShrinking", "error", "helperText", "helperTextState", "helperTextVisibility", "id", "label", "maxLength", "name", "onBlur", "onChange", "onFocus", "placeholder", "readOnly", "required", "separateLabel", "trailingIcon", "type", "value", "noTruncate", "parentRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { useTheme } from '@veneer/theme';
import { FormControl, FormHelperText, FormLabel, Input } from '../form_utils';
import styles from '../form_utils/input/styles';
import propTypes from './prop_types';
import { jsx as ___EmotionJSX } from "@emotion/react";
var TextBox = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
      background,
      className,
      defaultValue,
      disabled = false,
      disableLabelShrinking = false,
      error = false,
      helperText,
      helperTextState = 'default',
      helperTextVisibility = 'auto',
      id,
      label,
      maxLength,
      name,
      onBlur,
      onChange,
      onFocus,
      placeholder,
      readOnly = false,
      required = false,
      separateLabel = false,
      trailingIcon,
      type = 'text',
      value,
      noTruncate = false,
      parentRef
    } = _ref,
    inputProps = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
  var labelId = label && id ? "".concat(id, "-label") : undefined;
  var hasValue = value !== undefined;
  var maxWidthOffset = React.useMemo(() => {
    if (!label) {
      return undefined;
    }
    var {
      trailingButton
    } = inputProps;
    var filePickerOffset = "".concat(theme.orbitalEight, " + ").concat(theme.orbitalSix, " - 1px");
    if (type === 'file') return filePickerOffset;
    if (!trailingIcon && !trailingButton) return undefined;
    var maxWidthOffset = '0px';
    var offsetWithIcon = "".concat(theme.orbitalFive, " + ").concat(theme.orbitalFour, " + 1px");
    var trailingButtonOffset = theme.orbitalSeven;
    if (trailingIcon) maxWidthOffset += " + ".concat(offsetWithIcon);
    if (trailingButton && hasValue) maxWidthOffset += " + ".concat(trailingButtonOffset);
    return maxWidthOffset;
  }, [inputProps, theme, label, trailingIcon, type, hasValue]);
  var {
    files
  } = inputProps;
  var isTypeFile = type === 'file';
  var hasFiles = isTypeFile && !!files && files.length > 0;
  return ___EmotionJSX(FormControl, {
    background: background,
    className: className,
    customStyle: styles,
    disabled: disabled,
    error: error,
    helperTextState: helperTextState,
    required: required,
    separateLabel: separateLabel,
    hasTrailingItem: !!trailingIcon || !!(inputProps !== null && inputProps !== void 0 && inputProps.trailingButton)
  }, label && ___EmotionJSX(FormLabel, {
    htmlFor: id,
    id: labelId,
    isTypeFile: isTypeFile,
    maxWidthOffset: maxWidthOffset,
    shrink: hasFiles,
    disableLabelShrinking: disableLabelShrinking,
    noTruncate: noTruncate
  }, label), ___EmotionJSX(Input, _extends({}, inputProps, {
    "aria-describedby": helperTextId,
    "aria-invalid": error,
    "aria-required": required,
    defaultValue: defaultValue,
    id: id,
    inputIcon: trailingIcon,
    maxLength: maxLength,
    name: name,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    placeholder: placeholder,
    readOnly: readOnly,
    ref: ref,
    type: type,
    value: value,
    parentRef: parentRef
  })), helperText && ___EmotionJSX(FormHelperText, {
    helperTextVisibility: helperTextVisibility,
    id: helperTextId
  }, helperText));
});
TextBox.propTypes = propTypes;
TextBox.displayName = 'TextBox';
export default TextBox;